/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Work_0_DescInputs */

const en_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spoken-style tutoring dialogues that plan lessons and adapt to pace, streamed through a cost-aware inference gate.`)
};

const ar_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حوارات تعليمية منطوقة تخطط الدروس وتتكيف مع الإيقاع، تبث عبر بوابة استدلال واعية بالتكلفة.`)
};

const bn_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কথ্য শিক্ষণ সংলাপ যা পাঠ পরিকল্পনা করে আর গতির সাথে খাপ খায়, খরচ-সচেতন ইনফারেন্স গেটে প্রবাহিত।`)
};

const de_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprochene Tutor-Dialoge, die Lektionen planen und sich dem Tempo anpassen, gestreamt durch ein kostenbewusstes Inference-Gate.`)
};

const es_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogos de tutoría hablados que planifican lecciones y se adaptan al ritmo, transmitidos por un gateway de inferencia consciente del coste.`)
};

const fr_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des dialogues de tutorat parlés qui planifient les leçons et s'adaptent au rythme, diffusés via un gateway d'inférence sensible aux coûts.`)
};

const pt_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogos de tutoria falados que planificam lições e se adaptam ao ritmo, transmitidos por um gateway de inferência atento ao custo.`)
};

const zh_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会规划课程、适应节奏的口语家教对话，经成本感知的推理网关流式传输。`)
};

const tr_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersleri planlayan, tempoya uyan konuşma tarzı eğitmen diyalogları, maliyete duyarlı inference gateway'inden akar.`)
};

const ru_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голосовые тьютор-диалоги, которые планируют уроки и подстраиваются под темп, стримятся через гейт инференса с контролем цены.`)
};

const pl_svc_ai_voice_agents_work_0_desc = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mówione dialogi tutorskie, które planują lekcje i dostosowują się do tempa, streamowane przez gateway inferencji świadomy kosztów.`)
};

/**
* | output |
* | --- |
* | "Spoken-style tutoring dialogues that plan lessons and adapt to pace, streamed through a cost-aware inference gate." |
*
* @param {Svc_Ai_Voice_Agents_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_work_0_desc = /** @type {((inputs?: Svc_Ai_Voice_Agents_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_work_0_desc(inputs)
	return en_svc_ai_voice_agents_work_0_desc(inputs)
});
export { svc_ai_voice_agents_work_0_desc as "svc_ai-voice-agents_work_0_desc" }